import React from 'react';
import { connect } from 'react-redux';
import {
  deleteFavorite,
  deleteTooltip,
  mouseLeaveTooltip,
  overTooltip,
} from 'actions/NewTooltip';
import PropTypes from 'prop-types';
import MundialViews from 'containers/MundialViews';
import { clearWorkflowStart } from 'action-creators/payway/workflowStart';
import _ from 'underscore';
import * as actionsCarousel from '../action-creators/carousel';
import * as playAndGoParser from '../action-creators/playAndGoParser';
import * as actionsTV from '../action-creators/infinite';
import NewTooltip from 'components/carousel/NewTooltip/NewTooltip';
import { addFavorite } from '../actions/NewTooltip';
import LoadingSpinner from '../components/forms/LoadingSpinner';
import HomeCarousels from '../components/homeuser/HomeCarousels';
import InfiniteList from '../components/carousel/InfiniteList';
import SpecialView from './SpecialView';
import { ModalDeepLink } from './CardView/components/index';
import { labelsSelector } from './CardView/util/selectors';
import { GetRegion } from '../constants';
import * as actionsMetrics from '../action-creators/metrics';
import {
  setNavigationParamsUgly,
  setSecondMenuNavItemsDispatch,
  setSecondMenuSubMenuSelectedDispatch,
  setSecondMenuVisibilityDispatch,
  setSecondMenuCurrentSelectedDispatch,
} from '../reducers/nav/actions';
import { fetchEpgLineaUp } from 'containers/Player/actions/epgLineaUp';
//import { fetchEpgVersion } from 'containers/Player/actions/epgVersion';
import {fetchEpgVersion} from 'action-creators/epgVersion'
import { fetchEpgMenu } from 'containers/Player/actions/epgMenu';
import ScrollToTop from '../components/scrollTop/scrollToTop';
import NavigationWrapper from '../components/NavigationWrapper';
import { withRouterListener } from '../utils/hocs/withRouterListener';
import { getRegion } from '../utils/Region';
import getQueryParameter from '../utils/nav/getQueryParameter';
import { redirectMisContenidos } from 'utils/redirectMiscontenidos';

class HomeUserView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchCmsLevel: false,
      navChecked: false,
      isLoading: false,
      showModal: false,
      closeModal: false,
    };
    this.handleClickDeepLink = this.handleClickDeepLink.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentWillUnmount() {
    this.__mounted = false;
    this.props.history.unlisten();
    this.clearData();
  }

  componentDidMount() {
    this.props.flushOverLoad();
    this.props.clearWorkflowStart();
    this.clearData();
    this.fetchData();
    this.props.history.listen((location, action) => {
      if (
        !this.__mounted ||
        (this.props.location.pathname === location.pathname && action !== 'POP')
      ) {
        return;
      }

      this.clearData({ action });
    });

    this.__mounted = true;
    /* this.props.channels(
      this.props.config,
      { user_id: this.props.user.user_id },
      () => {},
    ); */

    /* this.props.channels(
      this.props.config,
      { user_id: this.props.user.user_id },
      () => {},
    ); */
  }

  fetchData = () => {
    if (!this.state.fetchCmsLevel) {
      const { node } = this.props.params;
      if (node?.includes('mundial2022')) {
        this.setState({
          fetchCmsLevel: true,
          isLoading: false,
        });
        return;
      }
      this.setState({
        fetchCmsLevel: true,
        isLoading: false,
      });
    }
  };

  UNSAFE_componentWillMount() {
    this.props.doSome(this.props.params);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.location.pathname == `/${GetRegion()}/misdescargas` &&
      !this.state.closeModal
    ) {
      this.setState({
        showModal: true,
      });
    }

    // TODO: VALIDATE -> WHY THIS?
    if (!this.state.navChecked && !nextProps.metadata.metadata) {
      const country = this.props.params?.country;
      this.props.navParser(country);
      this.setState({
        navChecked: true,
      });
    }

    if (nextProps.location.pathname !== this.props.location.pathname) {
      // reload data when changing section without unmounting
      // example: (series/movies/music)
      this.setState(
        {
          isLoading: true,
          fetchCmsLevel: false,
          fetchCmsLevelUser: false,
        },
        this.fetchData,
      );
    }

    if (this.props.params.node !== nextProps.params.node) {
      this.props.flushOverLoad();
    }
  }

  setMetrics(label, action) {
    const eventCategory = 'vcard';
    const eventAction = action;
    const eventLabel = label;

    this.props.setMetricsEvent({
      tagManager: {
        event: 'click',
        eventCategory,
        eventAction,
        eventLabel,
      },
    });

    this.props.setMetricsEvent({
      type: 'executor',
      success: true,
    });
  }

  clearData = location =>
    requestAnimationFrame(() => {
      // non blocking method
      this.props.setBackGround({ active: false });
      location &&
        location.action === 'POP' &&
        this.setState(
          {
            fetchCmsLevel: false,
          },
          this.fetchData,
        );
    });

  handleClickDeepLink() {
    setTimeout(() => {
      window.location = `/${GetRegion()}/${redirectMisContenidos()}`;
    }, 1000);
    this.setMetrics('si ya lo tengo', 'ya lo tienes');
    this.setState({
      closeModal: true,
    });
  }

  handleCloseModal() {
    this.setState({
      closeModal: true,
    });
    this.setMetrics('descargar aplicacion', 'ya lo tienes');
    window.location = `/${GetRegion()}/${redirectMisContenidos()}`;
  }

  render() {
    const {
      labels,
      newTooltip,
      handlerOverTooltip,
      handlerLeaveTooltip,
      handlerDeleteTooltip,
      handlerAddFavorite,
      handlerDeleteFavorite,
      translations,
      user,
    } = this.props;

    const { showModal, closeModal } = this.state;

    // Special View
    if (this.props.isSpecial) {
      return (
        <SpecialView node={this.props.params.node} special={this.props.params.node} />
      );
    }

    const isFetch = this.state.fetchCmsLevel;
    if (
      !this.props.config ||
      !isFetch ||
      this.state.isLoading ||
      Object.keys(this.props.metadata).length <= 1
    ) {
      return <LoadingSpinner />;
    }

    const layoutConfiguration = this.props.metadata.layout_node_configuration
      ? JSON.parse(this.props.metadata.layout_node_configuration)
      : false;
    const country = this.props.params?.country;
    const node = this.props.params?.node;
    const layoutRegion =
      layoutConfiguration[country] || layoutConfiguration.default || false;
    const layout =
      (layoutRegion[node] &&
        layoutRegion[node].type === 'layout' &&
        layoutRegion[node].layout) ||
      false;

    if (showModal && !closeModal) {
      return (
        <ModalDeepLink
          labels={labels}
          // id={this.episodeSelected.episodeId || params.id}
          onClickDeepLink={this.handleClickDeepLink}
          onClose={this.handleCloseModal}
          show={showModal}
          propsMetrics={this.props.setMetricsEvent}
        />
      );
    }
    if (closeModal) {
      return null;
    }

    if (node?.includes('mundial2022')) {
      return (
        <div>
          <MundialViews />
          <ScrollToTop />
        </div>
      );
    }
    if ((layout && layout === 'playandgo') || !this.props.isInfiniteList) {
      return (
        <div>
          <NavigationWrapper>
            <HomeCarousels params={this.props.params} />
          </NavigationWrapper>
          {newTooltip.isShowing && (
            <NewTooltip
              handlerOverTooltip={handlerOverTooltip}
              handlerLeaveTooltip={handlerLeaveTooltip}
              handlerDeleteTooltip={handlerDeleteTooltip}
              handlerAddFavorite={handlerAddFavorite}
              handlerDeleteFavorite={handlerDeleteFavorite}
              translations={translations}
              user={user}
              data={newTooltip}
            />
          )}
          <ScrollToTop />
        </div>
      );
    }
    // if ((layout && layout === 'TV') || this.props.isInfiniteList) {
    //   return (
    //     <div>
    //       <GridContentsView
    //         config={this.props.config}
    //         translations={this.props.translations}
    //         user={this.props.user}
    //         query={this.props.params}
    //         nav={this.props.nav}
    //       />
    //       <ScrollToTop />
    //     </div>
    //   );
    // }
  }
}

const mapStateToProps = (state, ownProps) => ({
  newTooltip: state.newTooltip,
  labels: labelsSelector(state),
  translations: state.translations,
  user: state.user,
  metadata: state.metadata,
  config: state.config,
  favorites: state.favorites,
  carousel: state.carousel,
  carrousels: state.carousel.carrousels,
  isInfiniteList: state.carousel.isInfiniteList,
  nav: state.nav.nodeList,
  checkLogin: state.checkLogin,
  isSpecial: ownProps.location.search.indexOf('especialesbts') !== -1,
  nodeList: state.nav.nodeList,
  currentSelected: state.nav.currentSelected,
  currentNode: state.navigation.currentNode,
  estado: state,
});

HomeUserView.propTypes = {
  params: PropTypes.object,
  labels: PropTypes.object,
  metadata: PropTypes.object,
  location: PropTypes.object,
  carrousels: PropTypes.array,
  fetchCmsLevel: PropTypes.func,
  fetchCmsLevelUser: PropTypes.func,
  routeParams: PropTypes.object,
  flushOverLoad: PropTypes.func,
  setBackGround: PropTypes.func,
  clearWorkflowStart: PropTypes.func,
};

const mapDispatchToProps = {
  navParser: playAndGoParser.navParser,
  flushOverLoad: actionsCarousel.flushOverLoad,
  setBackGround: actionsCarousel.setBackGround,
  channels: actionsTV.fetchPaywayLinealChannels,
  setMetricsEvent: actionsMetrics.setMetricsEvent,
  doSome: setNavigationParamsUgly,
  setSecondMenuSubMenuSelected: setSecondMenuSubMenuSelectedDispatch,
  setSecondMenuNavItems: setSecondMenuNavItemsDispatch,
  setSecondMenuVisibility: setSecondMenuVisibilityDispatch,
  setSecondMenuCurrentSelected: setSecondMenuCurrentSelectedDispatch,
  handlerOverTooltip: overTooltip,
  handlerDeleteTooltip: deleteTooltip,
  handlerLeaveTooltip: mouseLeaveTooltip,
  handlerAddFavorite: addFavorite,
  handlerDeleteFavorite: deleteFavorite,
  clearWorkflowStart: clearWorkflowStart,
  fetchEpgLineaUp,
  fetchEpgVersion,
  fetchEpgMenu,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouterListener(HomeUserView));
